import enTranslation from './locales/en/translation.json';

export const i18n_resources = {
  en: {
    translation: enTranslation,
  },
};
